/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-bind */
/*
 * Author M. Atoar Rahman
 * Title: D1 Form: Medicines Requisition for Facility
 * Description: D1 Form: Medicines Requisition for Facility
 * Date: 15/03/2022
 */

import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { getReq, setReq } from "./requisitionStore";
import useDataTableD1 from "./useDataTableD1";
import useMedicineList from "./useMedicineList";
import { getCached } from "./medicineListCache";

const RequestQtyCell = React.memo(({ row, onChange }) => {
  const drugId = row.drug_id ?? row.id;
  const savedValue = getReq(drugId).req_qty ?? "";

  return (
    <Form.Control
      size="sm"
      type="number"
      key={`req-${drugId}-${savedValue}`}
      defaultValue={savedValue}
      onChange={(e) => onChange(e.target.value, row, "req_qty")}
    />
  );
}, (prevProps, nextProps) => prevProps.row.drug_id === nextProps.row.drug_id);

const RemarksCell = React.memo(({ row, onChange }) => {
  const drugId = row.drug_id ?? row.id;
  const savedValue = getReq(drugId).remarks ?? "";

  return (
    <Form.Control
      size="sm"
      type="text"
      placeholder="Enter remarks"
      key={`rem-${drugId}-${savedValue}`}
      defaultValue={savedValue}
      onChange={(e) => onChange(e.target.value, row, "remarks")}
    />
  );
}, (prevProps, nextProps) => prevProps.row.drug_id === nextProps.row.drug_id);

export default function RequisitionTable({ id, month, year }) {
  const [data, setData] = useState();
  const getMedicineList = useMedicineList();

  useEffect(() => {
    const cached = getCached(id, { month, year });
    if (cached) {
      setData(cached);
      return undefined;
    }
    setData();
    let mounted = true;
    getMedicineList(id, { month, year })
      .then((list) => {
        if (mounted) {
          setData(list);
        }
      })
      .catch(() => {
        if (mounted) {
          setData(undefined);
        }
      });
    return () => {
      mounted = false;
    };
  }, [id, month, year, getMedicineList]);

  const requisitionRowHandler = useCallback((value, item, field = "req_qty") => {
    const drugId = item?.drug_id ?? item?.id;
    setReq(drugId, field, value, item);
  }, []);

  const columns = useMemo(() => [
    {
      name: "Item Names",
      selector: (row) => row.drug_name,
      sortable: true,
      wrap: true,
      width: "250px",
      fixed: true,
    },
    {
      name: "Opening Balance",
      selector: (row) => row.opening_balance,
      sortable: true,
    },
    {
      name: "Total Quantity Received During The Month",
      selector: (row) => row.received_qty,
      sortable: true,
    },
    {
      name: "Total Quantity Consumed By the Facility (OPD, IPD, Emergency, any other dept)",
      selector: (row) => row.consumed_qty,
      sortable: true,
      width: "150px",
    },
    {
      name: "Number Of Days Out Of Stock In The Pharmacy",
      selector: (row) => row.stock_out_days,
      sortable: true,
    },
    {
      name: "Average Monthly Consumption",
      selector: (row) => row.avg_monthly_consumption,
      sortable: true,
    },
    {
      name: "Total Quantities Returned To Main Agency Warehouse (Due To over stock)",
      selector: (row) => row.total_return,
      sortable: true,
      width: "150px",
    },
    {
      name: "Total Quanties Expired or Damaged",
      selector: (row) => row.expired_qty,
      sortable: true,
    },
    {
      name: "Earliest Date of Expiry of Physical Stocks",
      selector: (row) => row.expire_date,
      format: (row) => (row.expire_date ? moment(row.expire_date).format("DD MMM YYYY") : "N/A"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Closing Balance (Physical Stock)",
      selector: (row) => row.closing_balance,
      sortable: true,
    },
    {
      name: "Theoretical Stock",
      selector: (row) => row.theoritical_stock,
      sortable: true,
    },
    {
      name: "Number of Days of Physical Stock Available",
      selector: (row) => row.number_of_days_available_stock,
      sortable: true,
    },
    {
      name: "Request Qty",
      selector: (row) => row.req_qty,
      cell: (row) => (
        <RequestQtyCell
          row={row}
          onChange={requisitionRowHandler}
        />
      ),
      width: "150px",
      reorder: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => (
        <RemarksCell
          row={row}
          onChange={requisitionRowHandler}
        />
      ),
      width: "200px",
      reorder: true,
    },
  ], [requisitionRowHandler]);

  const search_column = useMemo(() => ({
    drug_name: "Name",
    opening_balance: "Opening Balance",
    received_qty: "Total Quantity Received During The Month",
    consumed_qty: "Total Quantity Consumed By the Facility (OPD, IPD, Emergency, any other dept)",
    stock_out_days: "Number Of Days Out Of Stock In The Pharmacy",
    avg_monthly_consumption: "Average Monthly Consumption",
    total_return: "Total Quantities Returned To Main Agency Warehouse (Due To over stock)",
    expired_qty: "Total Quanties Expired or Damaged",
    expire_date: "Earliest Date of Expiry of Physical Stocks",
    closing_balance: "Closing Balance (Physical Stock)",
    theoritical_stock: "Theoretical Stock",
    number_of_days_available_stock: "Number of Days of Physical Stock Available",
  }), []);

  return useDataTableD1({
    columns,
    data,
    search_column,
    pagination: false,
    is_DownloadButtonEnable: 0,
  });
}
